const ASC = 'asc'
const DESC = 'desc'

export default Object.freeze({
    ASC,
    DESC,
})
